'use strict';
import React from 'react';
import { Provider } from 'react-redux';
import CheckoutPage from 'checkout/checkoutPage';

export default class Checkout extends React.Component {
    componentWillMount() {
        this.props.cartStore.dispatch({
            type: 'redux-form/CHANGE',
            field: 'billing_is_shipping',
            value: true,
            touch: false,
            form: 'order_form'
        });
    }
    render() {
        return (
            <Provider store={this.props.cartStore}>
                <CheckoutPage {...this.props} />
            </Provider>
        );
    }
}



// WEBPACK FOOTER //
// ./static/app/checkout/index.jsx